var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconERbuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_4927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5873 18.3334H21.9988V14.6198H26.1538V11.6099H21.9988V7.85719H18.5873V11.6099H14.4322V14.6198H18.5873V18.3334Z",
    fill: "#C40000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4165 36.3378V0.455078H4.62996V36.3378H0.4662V39.5027H39.5382V36.3378H35.4165ZM8.08303 3.05825H32.0591V36.0318H26.2832V22.8175H13.9004V36.0318H8.08303V3.05825ZM23.179 36.0318H16.963V26.4868H23.179V36.0318Z",
    fill: "#C40000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_4927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconERbuilding);
export default __webpack_public_path__ + "static/media/Icon-ER+building.21918dedf41bf4b1bf1859282f9edc99.svg";
export { ForwardRef as ReactComponent };